import React from "react";
import { motion } from "framer-motion";
import UT from "../Images/UT.png";
import DU from "../Images/DU.png";

export default function Connect() {
  return (
    <div className="flex justify-center items-center py-12 px-4">
      <motion.div
        className="relative bg-[#0b1220] mt-5 text-white rounded-3xl h-[442px] md:w-[1240px] p-10 text-center shadow-lg"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        {/* Left Floating Arrow */}
        <motion.img
          src={UT}
          alt="Arrow Up"
          className="absolute md:w-100 hidden md:block top-0 left-0 "
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: [0, -5, 0] }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{ duration: 1.5, repeat: Infinity, repeatType: "reverse" }}
        />

        {/* Right Floating Arrow */}
        <motion.img
          src={DU}
          alt="Arrow Down"
          className="absolute md:w-150 md:block hidden  w-60 bottom-0 right-0 "
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: [0, 5, 0] }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{ duration: 1.5, repeat: Infinity, repeatType: "reverse" }}
        />

        {/* Heading */}
        <motion.h2
          className="text-2xl md:text-4xl mt-20 font-bold"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{ duration: 1, delay: 0.3 }}
          style={{fontFamily:'PT Sans'}}
        >
          Connect with <span className="text-[#7B61FF]">Godhani Technology</span>
        </motion.h2>

        {/* Subtitle */}
        <motion.p
          className="text-4xl text-gray-300 mt-2 font-[Allison]"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          Together we can make sure the world thrives.
        </motion.p>

        {/* Button */}
        <a href="mailto:hr@godhanitechnology.com">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="mt-6 bg-[#432DD7] cursor-pointer hover:bg-indigo-700 text-white px-6 py-3 rounded-full text-lg font-[400] font-[Nunito] transition"
        >
          Contact Us
        </motion.button>
      </a>

      </motion.div>
    </div>
  );
}
